export default "https://cdn.questicon.mathletics.com/assets/images/tick-91107868480cfd3fe0fe0647e20caea2.svg";